import React, { lazy, Suspense } from 'react';
import { Card, Container } from 'react-bootstrap';
import styles from './ClinicCalendar.module.scss';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import { Link } from 'react-router-dom';

const CalendarClinic = lazy(() => import('../components/CalendarClinic'));
const ClinicCalendar: React.FC = () => {
  return (
    <>
      <Container className="center">
        <h2 className={styles["title"]}>Consultório</h2>
        <Row className={styles["row-breadcrumb"]}>
          <Col>
            <Breadcrumb className={styles.breadcrumb}>
              <Breadcrumb.Item linkAs={Link} linkProps={{to:"/consultorio"}}>Consultório</Breadcrumb.Item>
              <Breadcrumb.Item active>Agenda</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
      </Container>
      <Container>
        <Row className={styles["row"]}>
          <Col>
            <Card>
              <Card.Body>
                <Suspense fallback={<Loader />}>
                  {/* Componente de calendário do consultório */}
                  <CalendarClinic />
                </Suspense>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ClinicCalendar;
